/* src/app/order/components/company-general-info/company-general-info.style.scss */
.general-company-info-form {
  display: flex;
  flex-direction: column;
}
.label {
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  font-family: Arial, sans-serif;
  color: #007d40;
  margin-bottom: 8px;
  text-transform: uppercase;
}
.flex-gap {
  display: flex;
  flex: 1 0 25px;
}
/*# sourceMappingURL=company-general-info.style.css.map */
